import { TaskFiltersInput } from 'generated/graphql';

export const arrayToUrl = (data: string[]) => {
    let result = '';
    for (const item of data) {
        result += `${item}-`;
    }
    return result;
};

export const urlToArray = (value: string) => value.split('-').slice(0, -1) as string[];

export interface IIndexFilters {
    clients: string[] | null;
    team: string[] | null;
    groups: string[] | null;
    search: string | null;
}

export const defaultIndexFilter: IIndexFilters = {
    clients: null,
    team: null,
    groups: null,
    search: null,
};

export const isChangedFilter = (filter: IIndexFilters) => {
    if (filter.clients !== defaultIndexFilter.clients) return true;
    if (filter.team !== defaultIndexFilter.team) return true;
    if (filter.groups !== defaultIndexFilter.groups) return true;
    if (filter.search !== defaultIndexFilter.search) return true;
};

export const filtersToSearchParams = (filter: IIndexFilters) => ({
    ...(filter.clients && { clients: arrayToUrl(filter.clients) }),
    ...(filter.team && { team: arrayToUrl(filter.team) }),
    ...(filter.groups && { epics: arrayToUrl(filter.groups) }),
    ...(filter.search && { search: filter.search }),
});

export const searchParamsToFilters = (params: URLSearchParams) =>
    ({
        clients: params.get('clients') ? urlToArray(params.get('clients')!) : defaultIndexFilter.clients,
        team: params.get('team') ? urlToArray(params.get('team')!) : defaultIndexFilter.team,
        groups: params.get('epics') ? urlToArray(params.get('epics')!) : defaultIndexFilter.groups,
        search: params.get('search') ? params.get('search') : defaultIndexFilter.search,
    } as IIndexFilters);

export const filtersToQuery = (filter: IIndexFilters) =>
    ({
        ...(filter.clients && { company: { id: { in: filter.clients } } }),
        ...(filter.team && { users: { id: { in: filter.team } } }),
        ...(filter.groups && { epic: { id: { in: filter.groups } } }),
        ...(filter.search && { name: { contains: filter.search } }),
    } as TaskFiltersInput);
